module.exports = __webpack_public_path__ + "img/account_circle.49e8fc02.svg";